/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { useModal } from '@/composables/useModal'
import { useNotify } from '@/composables/useNotify'
import { useFileExport } from '@/composables/useFileExport'
import { useSidebarLog } from '@/composables/useSidebarLog'
import { useRoute } from 'vue-router'

function openInteractionModal() {
    open(InteractionModal, {
        title: 'Do you want to export the security logs?',
        message: 'At this moment there is only csv expport without any variables.',
        onConfirm: async () => {
            const response = await exportSecurityLogsCsv()
            if (response.status === 200) {
                add({
                    message: 'Export successful',
                    type: 'success'
                })
            } else {
                add({
                    message: 'Export failed',
                    type: 'error'
                })
            }
        }
    })
}
export function useMetaActions() {

    const { open } = useModal()
    const { add } = useNotify()
    const route = useRoute()
    const { openLog } = useSidebarLog()

    async function openInteractionModal(title, message, onConfirm) {
        open(InteractionModal, {
            title: title,
            message: message,
            async onConfirm() {
                try {
                    const response = await exportSecurityLogsCsv()

                    const blob = response.data
                    const url = window.URL.createObjectURL(blob)

                    const link = document.createElement('a')
                    link.href = url
                    link.download = 'security_logs.csv'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    window.URL.revokeObjectURL(url)

                    add({
                        message: 'Export successful',
                        type: 'success'
                    })

                } catch (e) {
                    add({
                        message: 'Export failed',
                        type: 'error'
                    })
                }
            }
        })
    }

    function handle(action) {

        switch (action.action) {

            case 'create':
                open(BlueprintFormModal, {
                    title: `New ${route.meta.entity}`,
                    message: `Create new ${route.meta.entity}?`,
                    onConfirm: () => {
                        add({
                            message: `${route.meta.entity} created`,
                            type: 'success'
                        })
                    }
                })
                break

            case 'export_csv':
                openInteractionModal('Export Security Logs', 'Do you want to export the security logs as CSV?', async () => {
                    try {
                        const response = await exportSecurityLogsCsv()
                        if (response.status === 200) {
                            add({
                                message: 'Export successful',
                                type: 'success'
                            })
                        } else {
                            throw new Error('Export failed')
                        }
                    } catch (e) {
                        add({
                            message: 'Export failed',
                            type: 'error'
                        })
                    }
                })
                break

            case 'export_pdf':
                openInteractionModal('Export Security Logs', 'Do you want to export the security logs as PDF?', async () => {
                    try {
                        const response = await exportSecurityLogsPdf()
                        if (response.status === 200) {
                            add({
                                message: 'Export successful',
                                type: 'success'
                            })
                        } else {
                            throw new Error('Export failed')
                        }
                    } catch (e) {
                        add({
                            message: 'Export failed',
                            type: 'error'
                        })
                    }
                })
                break

            case 'audit':
                openLog(route.meta.key)
                break

            case 'unlock':
                add({
                    message: 'Unlock not implemented yet',
                    type: 'info'
                })
                break

            default:
                console.warn('Unknown meta action:', action)
        }
    }

    return { handle }
}